var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:( _obj = {}, _obj[("alert-" + _vm.type)] = _vm.type, _obj )},[_c('div',{staticClass:"d-flex align-items-center"},[(_vm.icon)?_c('ui-icon',{staticClass:"mr-4",attrs:{"name":_vm.icon,"size":"32px"}}):_vm._e(),_c('div',{staticClass:"flex-fill"},[(_vm.title)?_c('strong',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.message))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }